import { useState } from "react";
import '../css/cseDeptStyle.css';
const HindiPage = () => {
    return (
        <><div className="dept-wrapper">
            <div className="container">
                <section className="py-4 header">
                    <header>
                        {/* <img
                            src="https://nitw.ac.in/api/static/files/ciks_2025-4-2-17-6-30.jpg" className="img-fluid" /> */}
                        <center><h2>Hindi Cell</h2></center>
                    </header>
                    <div className="row">

                        <div className="col-md-2">
                            <div className="head_of_dept"> <a href="#"
                                target="_blank"> <img src="https://nitw.ac.in/api/static/files/Director_image1_2023-5-20-12-32-22.jpg" alt="" className="img-fluid" width="240" height="200" />
                            </a>
                            </div>
                        </div>
                        <div className="col-md-10">
                            <br />
                            <b className="justified-text">नाम/Name - प्रोफेसर बिद्याधर सुबुधि/Prof. Bidyadhar Subudhi <br />
                                पद/Designation – निदेशक/Director <br />

                                ईमेल/Email – director@nitw.ac.in<br />

                                दूरभाष/Phone – 0870 246 2000

                            </b>
                        </div>

                    </div>
                    <div className="row">

                        <div className="col-md-2">
                            <div className="head_of_dept"> <a href="#"
                                target="_blank"> <img src="https://nitw.ac.in/api/static/files/registrar_2025-4-11-19-36-22.png" alt="" className="img-fluid" width="240" height="200" />
                            </a>
                            </div>
                        </div>
                        <div className="col-md-10">
                            <br />
                            <b className="justified-text">नाम/Name - श्री सुनील कुमार मेहता/ Shri Sunil Kumar Mehta <br />
                            पद/Designation – कुलसचिव/Registrar <br />

                            ईमेल/Email – registrar@nitw.ac.in<br />

                            दूरभाष/Phone – 0870 246 2010

                            </b>
                        </div>

                    </div>



                </section>
            </div>
        </div>

        </>
    );
}
export default HindiPage;